(() => {
  if (window.__cImageSplitInitialized) return;
  window.__cImageSplitInitialized = true;

  const init = () => {
    const sections = Array.from(document.querySelectorAll('.c_image-split'));
    if (!sections.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    const maxShift = 25;
    const lerp = 0.10;

    sections.forEach((section) => {
      const items = Array.from(section.querySelectorAll('.c_image-split__item'));

      items.forEach((item) => {
        const mediaEl = item.querySelector('.c_image-split__media');
        if (!mediaEl || !mediaEl.querySelector('img')) return;

        const state = {
          frameEl: item,
          mediaEl,
          current: 0,
          top: 0,
          height: 0,
          rafId: null,
        };

        function calcMetrics() {
          const rect = state.frameEl.getBoundingClientRect();
          state.top = rect.top + window.scrollY;
          state.height = rect.height;
        }

        function getTarget() {
          const vh = window.innerHeight || 1;
          const center = (state.top - window.scrollY) + state.height / 2;
          const norm = (center / vh - 0.5) * 2;
          return Math.max(-1, Math.min(1, norm)) * maxShift;
        }

        function tick() {
          const target = getTarget();
          state.current += (target - state.current) * lerp;
          if (Math.abs(target - state.current) < 0.1) state.current = target;
          state.mediaEl.style.transform = `translate3d(0, ${state.current.toFixed(2)}px, 0)`;
          state.rafId = requestAnimationFrame(tick);
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!state.rafId) state.rafId = requestAnimationFrame(tick);
            } else {
              if (state.rafId) { cancelAnimationFrame(state.rafId); state.rafId = null; }
            }
          });
        }, { threshold: 0, rootMargin: '100px 0px' });

        observer.observe(item);

        window.addEventListener('resize', calcMetrics);
        window.addEventListener('load', calcMetrics);
        calcMetrics();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
